<template>
    <div>
        <div v-if="!isWebApp" class="mb-2">
            <b-button
                    variant="link"
                    size="sm"
                    class="pl-0"
                    @click="$router.push('/requests/delete-shift-report')"
            >
                <i class="fas fa-arrow-left mr-1"></i>
                Назад к аннулированию отчётов
            </b-button>
        </div>
        <HorizontalStepper
            :steps="steps"
            locale="ru"
            :reset="true"
            @stepper-finished="onFinishClick"
            :keep-alive="false"
        />
    </div>
</template>

<script>
import HorizontalStepper from "vue-stepper";
import OneStep from "./Steps/OneStep";
import TwoStep from "./Steps/TwoStep";
import ThreeStep from "./Steps/ThreeStep";
import {
    awaitInstallPromotionAfterSuccess,
    notifyInstallPromotionSuccess
} from "@/utils/installPromotion";

export default {
    name: "RequestCreate",
    components: {
        HorizontalStepper
    },
    computed: {
        selectedShifts() {
            return this.$store.state.deleteShiftReport.selectedShifts;
        },
        selectedObject() {
            return this.$store.state.deleteShiftReport.selectedObject;
        },
        isWebApp() {
            return this.$store.getters.isTelegramWebApps;
        },
        sendOnCreate() {
            return this.$store.state.deleteShiftReport.sendOnCreate;
        },
        editRequest() {
            return this.$store.state.deleteShiftReport.editRequest;
        }
    },
    data() {
        return {
            shifts: [],
            selected: [],
            objects: [],
            objectFind: ``,
            onProcess: false,
            selectedProcess: null,
            steps: [
                {
                    icon: 'home',
                    name: 'oneStep',
                    title: 'Строительный объект',
                    subtitle: '',
                    component: OneStep,
                    completed: false
                },
                {
                    icon: 'list',
                    name: 'twoStep',
                    title: 'Доступные смены',
                    subtitle: '',
                    component: TwoStep,
                    completed: false
                },
                {
                    icon: 'done',
                    name: 'threeStep',
                    title: 'Выбранные смены',
                    subtitle: '',
                    component: ThreeStep,
                    completed: false
                }
            ]
        }
    },
    methods: {
        async onFinishClick() {
            const {createRequest, updateRequest, $store, $bvModal, isWebApp, sendOnCreate, editRequest} = this;
            let requestId;
            if (editRequest && (editRequest.status === 0)) {
                await updateRequest();
                await $bvModal.msgBoxOk(`Заявка успешно обновлена!`);
                await $store.dispatch(`deleteShiftReport_clearStepper`);
                requestId = editRequest.id;
            } else {
                const request = await createRequest();
                requestId = request.id;
                if ((Number(request.author) === Number(request.inspector)) && sendOnCreate) {
                    await $store.dispatch(`deleteShiftReport_submitCreatedRequest`, request);
                    await $bvModal.msgBoxOk(`Заявка вами согласована и исполнена системой!`);
                } else {
                    const msg = sendOnCreate
                        ? `Заявка успешно направлена куратору на согласование!`
                        : `Заявка успешно создана в статусе Черновик!`;
                    await $bvModal.msgBoxOk(msg);
                    if (sendOnCreate) {
                        await $store.dispatch(`deleteShiftReport_submitCreatedRequest`, request);
                    }
                }
                await $store.dispatch(`deleteShiftReport_clearStepper`);
            }

            if (isWebApp) {
                await awaitInstallPromotionAfterSuccess({source: 'delete-shift-report-request'});
                window.Telegram.WebApp.close();
            } else {
                notifyInstallPromotionSuccess({source: 'delete-shift-report-request'});
                await this.$router.push(`/requests/delete-shift-report#${requestId}`);
            }
        },
        createRequest() {
            const {selectedShifts, selectedObject: {building_process_id, curator_id}} = this;
            const payload = {
                inspector: curator_id,
                buildingProcess: building_process_id,
                shifts: selectedShifts.map(({shift_id, cause, telegram_message_id, date_time_begin}) => ({shift_id, cause, telegram_message_id, date_time_begin}))
            };
            return this.$store.dispatch(`deleteShiftReport_createRequest`, payload);
        },
        updateRequest() {
            const {selectedShifts, selectedObject: {building_process_id, curator_id}, editRequest} = this;
            const payload = {
                inspector: curator_id,
                buildingProcess: building_process_id,
                shifts: selectedShifts.map(({shift_id, cause, telegram_message_id, date_time_begin}) => ({shift_id, cause, telegram_message_id, date_time_begin}))
            };
            return this.$store.dispatch(`deleteShiftReport_updateRequest`, {id: editRequest.id, payload});
        }
    }
}
</script>

<style>
.w30px {
    width: 30px;
}
</style>
